import { render, staticRenderFns } from "./BillingNew.vue?vue&type=template&id=71d8c347"
import script from "./BillingNew.vue?vue&type=script&lang=js"
export * from "./BillingNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports